// extracted by mini-css-extract-plugin
module.exports = {"container":"PrecisionPanel_container__2zL9j","description":"PrecisionPanel_description__1cFe3","buttons":"PrecisionPanel_buttons__3I2mS","button":"PrecisionPanel_button__HdEPx"};